import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

const Cards = async () => {
    gsap.registerPlugin(ScrollTrigger);

    const fadeUp = elements => {
        if (elements.length) {
            ScrollTrigger.batch(elements, {
                // interval: 0.2,
                // batchMax: 2,
                onEnter: batch => gsap.to(batch, {
                    autoAlpha: 1,
                    stagger: 0.1,
                    y: 0,
                    duration: 0.5,
                    ease: "power1.out",
                }),
                start: 'top 90%'
            });
        }
    }

    fadeUp(document.querySelectorAll('[data-gsap-fade-up]'));
    fadeUp(document.querySelectorAll('[data-typography-fade-up] > *'));
}

export default Cards;